import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { NavigationListProvider } from '../../providers/navigation-list/navigation-list';

import { RegisterPage } from '../register/register';
import { ForgotpswdPage } from '../forgotpswd/forgotpswd';
import { LoginProvider, Credentials } from '../../providers/login/login';
import { PageBase } from '../page-base';
import { DataProvider } from '../../providers/data/data';
import { HomePage } from '../home/home';
import { MenuPage } from '../menu/menu';
import { CompanyConfigProvider } from '../../providers/company-config/company-config';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AppConfig } from '../../config/app.config';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage extends PageBase {

  username: string;
  password: string;

  showRegistrationButton = false;
  showContinueButton = false;

  loginForm: FormGroup;
  submitAttempt: boolean;

  constructor(private loginProvider: LoginProvider,
    private navigationList: NavigationListProvider,
    private navCtrl: NavController,
    private companyConfigProvider: CompanyConfigProvider,
    private formBuilder: FormBuilder,
    private iab: InAppBrowser) {
    super();

    this.initForm();

    this.companyConfigProvider.isLoginRequired().then(x => {
      this.showContinueButton = !x;
    });

    this.companyConfigProvider.isRegistrationAllowed().then(x => {
      this.showRegistrationButton = x;
    });

    this.loginProvider.isAuthenticated().then(x => {
      if (x) this.continue();
    });
  }

  initForm() {
    this.loginForm = this.formBuilder.group({
      mail: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required])]
    });
  }

  keyPressHandler(keyCode) 
  {
    if(keyCode == 13) {
      this.login();
    }
  }

  login() {
    if (!this.loginForm.valid) {
      // Form invalid
      this.submitAttempt = true;
      return;
    }
    this.loadingProvider.start('LOGGING_IN');
    this.loginProvider.login(new Credentials(this.username, this.password)).then((success) => {
      if (success) {
        // Successful login
        this.continue();
      } else {
        // Failed login
        this.loadingProvider.stop();
        this.submitAttempt = true;
      }
    }).catch(err => {
      // Failed login
      this.loadingProvider.stop();
      this.submitAttempt = true;
    });
  }

  continueWithoutLogin() {
    this.loadingProvider.start('');
    this.loginProvider.startAnonymousSession().then(() => {
      this.continue();
    }).catch(err => {
      this.loginFailed();
    });
  }

  loginFailed() {
    this.loadingProvider.stop();
    this.alertProvider.error(this.translate.instant('ERROR.LOGIN_FAILED'));
  }

  continue() {
    this.navigationList.loadCategoryListItems().then(() => {
      this.companyConfigProvider.syncCompanyConfig();
      this.loadingProvider.stop();
      this.navCtrl.setRoot(MenuPage);
    });
  }

  register() {
    this.navCtrl.push(RegisterPage);
  }

  passwordForgot() {
//     this.iab.create('http://newbackend.toffer.io/forgot_password.php?store_uuid=' + this.appConfig.companyId, '_blank').show();
	this.navCtrl.push(ForgotpswdPage);

  }

  usernameForgot() {
    this.iab.create('http://newbackend.toffer.io/forgot_username.php?store_uuid=' + this.appConfig.companyId, '_blank').show();
  }
}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts